import { createClient, ApiError } from '@shared/api/client.js';
import { getLocale } from '@shared/i18n/index.js';

// The microsite is public and stateless — nothing here needs a token.
export const api = createClient({
  baseUrl: import.meta.env.VITE_API_BASE_URL || '/api/v1',
  getLocale,
});

export { ApiError };
export default api;
